import { Button } from "@mui/material"
import companyLogo from "@assets/images/S&P_Global_logo.svg"
import { useNavigate } from "react-router"

export default function SomethingWentWrong() {
  const history = useNavigate()
  return (
    <div className="displayContainer">
      <img className="companyLogo" src={companyLogo} alt="S&P Global" />
      <h1>
        500 Something went wrong <b>:(</b>
      </h1>
      <Button variant="contained" onClick={() => history(-1)}>
        Go back
      </Button>
    </div>
  )
}
